import { THEMES } from '~/managers/index';

export default async function ({ req, res, $config, store, app, route }) {
    const CURRENT_THEME = $config.THEME;
    // const isFoundation = process.env.THEME === 'FOUNDATION'; // TEMPORARY

    // if (isFoundation) {
    //     return;
    // }

    const mainLang = store.getters['global/getMainlang'];
    const userAgent = process.server ? req.headers['user-agent'] : '';
    const isBot =
        /bot|crawler|spider|crawling|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|Slackbot-LinkExpanding|WhatsApp|Viber|TelegramBot|Pinterest|Googlebot|Bingbot|YandexBot|DuckDuckBot|Baiduspider|Applebot|SemrushBot|PetalBot|AhrefsBot|MJ12bot|Sogou/i.test(
            userAgent
        );

    app.i18n.onLanguageSwitched = oldLocale => {
        store.commit('SET_PREVIOUS_LOCALE', oldLocale);
    };

    let locale = app.$cookies.get('i18n_redirected')
        ? app.$cookies.get('i18n_redirected')
        : mainLang
        ? mainLang
        : process.server
        ? req.headers['accept-language']
        : app.i18n.locale;

    if (!app.$cookies.get('first_lang_visit') && !isBot) {
        app.$cookies.set('i18n_redirected', locale);
        app.$cookies.set('language', locale);
        app.$cookies.set('first_lang_visit', true);
        app.$cookies.set('getPreviousLocale', route.path.split('/')[1]);
    } else {
        app.$cookies.set('getPreviousLocale', route.path.split('/')[1]);
    }

    if (!route.path.startsWith(`/${locale}`)) {
        // console.log('tut', route);

        if (!isBot) {
            await app.i18n.setLocale(locale);
        }

        const availableLocales = app.i18n.locales.map(locale => locale.code);
        const currentLocaleInPath = route.path.split('/')[1];
        // console.log(app.$cookies, 'cook', process.client);
        // res.setHeader('Set-Cookie', [`cookie_name=${currentLocaleInPath}; Path=/; HttpOnly`]);
        // // app.$cookies.set('getPreviousLocale', currentLocaleInPath);
        store.commit('SET_PREVIOUS_LOCALE', currentLocaleInPath);
        if (!availableLocales.includes(currentLocaleInPath)) {
            if (process.server) {
                console.log('serverredirect');
                res.writeHead(302, {
                    Location: route.path === '/' ? `/${locale}${route.fullPath.slice(1)}` : `/${locale}${route.fullPath}`
                });
                res.end();
            }
        }
    }

    return;

    // if (THEMES.ecom === CURRENT_THEME) {
    //     const isFirstVisit = app.$cookies.get('i18n_redirected');

    //     if (!isFirstVisit) {
    //         let locale = mainLang ? mainLang : req.headers['accept-language'];

    //         if (route.path.startsWith('/')) {
    //             locale = app.i18n.defaultLocale;
    //         }

    //         if (route.path.startsWith('/ro')) {
    //             locale = 'ro';
    //         }

    //         if (route.path.startsWith('/en')) {
    //             locale = 'en';
    //         }

    //         await app.i18n.setLocale(locale);
    //     }
    // }
}
